<template>
  <content-section
    title="Check-in Automatico"
    :background_color="sass('selected')"
  >
    <div class="check-in-status">
      <div
        v-for="(flight, index) in visible_flights"
        :key="`${flight.itinerary_key}:${index}`"
        class="check-in-status__container"
        :class="{
          'check-in-status__container--bordered':
            index < visible_flights.length - 1,
        }"
      >
        <flight-check-in-status
          :flight="flight"
          :is_homogenous_state="is_homogenous_state"
        />
      </div>
      <flight-check-in-status
        v-if="visible_flights.length === 0"
        :flight="{
          status: status_summary,
          boarding_passes: [],
        }"
        is_homogenous_state
      />
    </div>
  </content-section>
</template>

<script>
  import { as_compare_string } from '@liveflight/utilities/mixins';
  import ContentSection from '@liveflight/components/blocks/wrappers/content-section.vue';
  import FlightCheckInStatus from '@liveflight/components/blocks/check-in/flight-check-in-status.vue';

  export default {
    name: 'check-in-status',
    components: {
      'content-section': ContentSection,
      'flight-check-in-status': FlightCheckInStatus,
    },
    props: {
      status_summary: {
        type: String,
        default: () => 'not_requested',
      },
      flights: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      is_homogenous_state() {
        if (this.flights.length <= 1) {
          return true;
        }
        const { status: first_status } = this.flights[0];
        if (as_compare_string(first_status) === 'success') {
          return false;
        }

        return this.flights.every(
          (flight) =>
            as_compare_string(first_status) === as_compare_string(flight.status)
        );
      },
      visible_flights() {
        if (!this.flights.length) {
          return [];
        }
        if (this.is_homogenous_state && this.flights.length > 1) {
          return [this.flights[0]];
        }
        return this.flights;
      },
      all_boarding_passes() {
        return (this.flights || []).reduce(
          (map, flight) => ({
            ...map,
            [flight.itinerary_key]: flight.boarding_passes,
          }),
          []
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .check-in-status {
    margin-top: $grid-gutter-width * 2 / 3;
    line-height: normal;
    display: flex;
    flex-direction: column;
    gap: $grid-gutter-width / 2;
    font-size: 14px;

    &__container--bordered {
      padding-bottom: $grid-gutter-width / 2;
      border-bottom: 1px solid $gray-200;
    }
  }
</style>
